<template>
  <section id="section" class="slideDown">
    <div class="back" @click="back()">{{$t('general.return')}}</div>

    <div class="container">
      <h3 class="title"><span>{{ $t('admin.mop.title') }}</span></h3>

      <div class="contact_info">
        <div class="subtitle">{{ $t('admin.mop.subtitle_order') }}</div>
        <div class="clear" style="height:20px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.order_number') }}</span
          ><b
            ><span>{{ order.name }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('general.date') }}</span
          ><b
            ><span>{{ formatDate(order.date) }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.status') }}</span>
          <select v-model="current_order.status" :items="status">
            <option v-for="(option, index) in status" :value="option.id">{{
              option.name
            }}</option>
          </select>
        </div>
        <div class="buttons" v-show="current_order.status != order.status">
          <v-btn large color="success" @click="save">{{ $t('general.save') }}</v-btn>  
        </div>
        <div class="clear" style="height:30px"></div>
        <div class="subtitle">{{ $t('general.contact') }}</div>
        <div class="clear" style="height:20px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.name') }}</span
          ><b
            ><span>{{ order.contact_name }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.phone') }}</span
          ><b
            ><span>{{ order.contact_phone }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.email') }}</span
          ><b
            ><span>{{ order.contact_email }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('admin.mop.site') }}</span
          ><b
            ><span>{{ order.restaurant_site }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param">
          <span class="label">{{ $t('general.restaurant') }}</span
          ><b
            ><span>{{ order.restaurant_name }}</span></b
          >
        </div>
        <div class="clear" style="height:10px"></div>
        <div class="param" v-if="order.restaurant_razon">
          <span class="label">{{ $t('admin.mop.razon') }}</span
          ><b
            ><span>{{ order.restaurant_razon }}</span></b
          >
        </div>
      </div>
      <div class="content">
        <div v-for="(item, index) in order.items" class="item" :key="item.id">
          <div class="box-resume">
            <img class="image" :src="item.from.image" />

            <div class="container">
              <div class="from">
                <div class="item" v-if="item.from.filename">
                  <label>{{ $t('general.resource') }}</label
                  ><span class="value">{{ item.from.filename }}</span>
                </div>
                <div class="item" v-if="item.from.reference">
                  <label>{{ $t('general.reference_abbreviation') }}</label
                  ><span class="value">{{ item.from.reference }}</span>
                </div>
                <div class="item" v-if="item.from.link">
                  <label>{{ $t('admin.mop.link') }} </label
                  ><a class="value" target="_blank" :href="item.from.link"
                    >{{ $t('general.piece') }}</a
                  >
                </div>
                <div class="item" v-if="item.from.filename">
                  <label>{{ $t('admin.mop.budget') }}</label 
                  ><span class="value">{{ method[item.method] }}</span>
                </div>
                <div v-if="!item.to.file && !item.to.filename" class="label">
                  {{ $t('admin.mop.no_adaptation') }}
                </div>
                <div v-else class="label">{{ $t('admin.mop.adaptation') }}:</div>
                <div class="item" v-if="item.to.file">
                  <label>{{ $t('general.format') }}</label
                  ><span class="value">{{
                    types[item.to.file].name.toUpperCase()
                  }}</span>
                </div>
                <div class="item" v-if="item.to.filename">
                  <label>{{ $t('general.dimensions') }}</label
                  ><span class="value"
                    >{{ sizes[item.to.file][item.to.filename].name }}
                    <span v-if="sizes[item.to.file][item.to.filename].custom"
                      ><br />{{ item.to.size }}</span
                    ></span
                  >
                </div>
              </div>
              <div class="to">
                <div class="item">
                  <label>{{ $t('general.invoice') }}</label
                  ><span class="value"
                    >{{ locations[item.billed].site }} -
                    {{ locations[item.billed].name }}
                    {{ locations[item.billed].cif }}</span
                  >
                </div>
                <div class="item" v-if="item.method == 2">
                  <label>{{ $t('general.send_to') }}</label
                  ><span class="value">
                    <template v-if="item.custom_ship">
                      {{ item.custom_ship }}
                    </template>
                    <template v-else>
                      {{ locations[item.shipped].site }} -
                      {{ locations[item.shipped].name }}
                      {{ locations[item.shipped].cif }}
                    </template>
                  </span>
                </div>
                <div class="item" v-if="item.method == 2">
                  <label>{{ $t('general.unit') }}</label
                  ><span v-if="item.units_scale_custom" class="value">{{
                    item.units_scale_custom
                  }}</span
                  ><span v-else class="value">{{ item.units_scale }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-info">
            <div class="personalitzation">
              <div class="item title">
                <label>{{ $t('general.personalization') }}</label
                ><span
                  v-if="item.custom == null && !item.custom_file"
                  class="value"
                  >{{ $t('general.no_personalization') }}</span
                >
              </div>
              <div
                class="item"
                v-if="
                  item.custom != null &&
                    item.custom.restaurant &&
                    item.custom.restaurant != ''
                "
              >
                <label>{{ $t('general.restaurant') }}</label
                ><span class="value">{{ item.custom.restaurant }}</span>
              </div>
              <div class="item" v-if="item.custom != null && item.custom.price">
                <label>{{ $t('general.price') }}</label
                ><span class="value">{{ item.custom.price }}</span>
              </div>
              <div
                class="item"
                v-if="item.custom != null && item.custom.schedule"
              >
                <label>{{ $t('general.schedule') }}</label
                ><span class="value">{{ item.custom.schedule }}</span>
              </div>
              <div class="item" v-if="item.custom != null && item.custom.date">
                <label>{{ $t('general.date') }}</label
                ><span class="value">{{ item.custom.date }}</span>
              </div>
              <div class="item" v-if="item.custom_file">
                <label>{{ $t('general.file') }}</label
                ><span class="value"
                  ><a :href="item.custom_file" target="_blank"
                    >{{ $t('admin.mop.download') }}</a
                  ></span
                >
              </div>
              <div
                class="item"
                v-if="item.custom != null && item.custom.others"
              >
                <label>{{ $t('general.others') }}</label
                ><span class="value">{{ item.custom.others }}</span>
              </div>
            </div>
            <div class="questions">
              <div
                class="item title"
                v-if="Object.keys(item.params).length > 0"
              >
                  <label>{{ $t('general.questions') }}</label><span class="value"></span>
              </div>
              <div class="item" v-if="item.params.q1">
                <label>{{ $t('admin.mop.cupouns') }}</label>
                <span v-if="item.params.q1 == 1" class="value">Sí</span>
                <span v-if="item.params.q1 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.q2">
                <label>{{ $t('admin.mop.trolley') }}</label>
                <span v-if="item.params.q2 == 1" class="value">Sí</span>
                <span v-if="item.params.q2 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.q4">
                <label>{{ $t('admin.mop.rounded') }}</label>
                <span v-if="item.params.q4 == 1" class="value">Sí</span>
                <span v-if="item.params.q4 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.q5">
                <label>{{ $t('admin.mop.magazine') }}</label>
                <span v-if="item.params.q5 == 1" class="value">Revista</span>
                <span v-if="item.params.q5 == 0" class="value">Períodico</span>
              </div>
              <div class="item" v-if="item.params.q6">
                <label>{{ $t('admin.mop.support') }}</label>
                <span v-if="item.params.q6 == 1" class="value">Sí</span>
                <span v-if="item.params.q6 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.q7">
                <label>{{ $t('admin.mop.peana') }}</label>
                <span v-if="item.params.q7 == 1" class="value">Sí</span>
                <span v-if="item.params.q7 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.q8">
                <label>{{ $t('admin.mop.envelopes') }}</label>  
                <span v-if="item.params.q8 == 1" class="value">Sí</span>
                <span v-if="item.params.q8 == 0" class="value">No</span>
              </div>
              <div class="item" v-if="item.params.custom_file">
                <label>{{ $t('general.file') }}</label
                ><span class="value"
                  ><a :href="item.params.custom_file" target="_blank"
                    >{{ $t('general.download') }}</a
                  ></span
                >
              </div>
              <div class="item" v-if="item.params.custom">
                <label>{{ $t('general.others') }}</label
                ><span class="value">{{ item.params.custom }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="item"><label>Personalización:</label><span v-if="item.custom == null && !item.custom_file" class="value">Sin personalización</span></div>
              <div class="custom">
                <div class="item" v-if="item.custom != null && item.custom.restaurant && item.custom.restaurant != ''"><label>Restaurante:</label><span class="value">{{ item.custom.restaurant }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.price"><label>Precio:</label><span class="value">{{ item.custom.price }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.schedule"><label>Horario:</label><span class="value">{{ item.custom.schedule }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.date"><label>Fecha:</label><span class="value">{{ item.custom.date }}</span></div>
                <div class="item" v-if="item.custom_file"><label>Fichero:</label><span class="value"><a :href="item.custom_file" target="_blank">Descargar</a></span></div>
                <div class="item" v-if="item.custom != null && item.custom.others"><label>Otros:</label><span class="value">{{ item.custom.others }}</span></div>
              </div>
            </div>
            <div class="item" v-if="Object.keys( item.params ).length > 0"><label>Preguntas:</label><span class="value"></span></div>
              <div class="custom">
                <div class="item" v-if="item.params.q1">
                  <label>¿Con cupones?:</label>
                  <span v-if="item.params.q1 == 1" class="value">Sí</span>
                  <span v-if="item.params.q1 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q2">
                  <label>* ¿Quieres que estén troquelados?:</label>
                  <span v-if="item.params.q2 == 1" class="value">Sí</span>
                  <span v-if="item.params.q2 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q4">
                  <label>* ¿Con cantos redondeados?:</label>
                  <span v-if="item.params.q4 == 1" class="value">Sí</span>
                  <span v-if="item.params.q4 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q5">
                  <label>* Indica si es para revista o periódico:</label>
                  <span v-if="item.params.q5 == 1" class="value">Revista</span>
                  <span v-if="item.params.q5 == 0" class="value">Períodico</span>
                </div>
                <div class="item" v-if="item.params.q6">
                  <label>* ¿Necesitas recibir soporte?:</label>
                  <span v-if="item.params.q6 == 1" class="value">Sí</span>
                  <span v-if="item.params.q6 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q7">
                  <label>* ¿Necesitas recibir peana?:</label>
                  <span v-if="item.params.q7 == 1" class="value">Sí</span>
                  <span v-if="item.params.q7 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q8">
                  <label>* ¿Con sobres?:</label>
                  <span v-if="item.params.q8 == 1" class="value">Sí</span>
                  <span v-if="item.params.q8 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.custom_file"><label>* Fichero:</label><span class="value"><a :href="item.params.custom_file" target="_blank">Descargar</a></span></div>
                <div class="item" v-if="item.params.custom"><label>* Otros:</label><span class="value">{{ item.params.custom }}</span></div>
              </div>
            </div>

          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '@/i18n'
export default {
  props: { order: Object },
  data () {
    return {
      status: this.$store.getters['orders/getOrderStatus'],
      sizes: this.$store.getters['orders/getSizes'],
      questions: this.$store.getters['orders/getQuestions'],
      personalization: this.$store.getters['orders/getPersonalizations'],
      description: this.$store.getters['orders/getDescriptions'],
      current_order: {},
      method: {
        '1': 'Adaptación arte final',
        '2': 'Adaptación arte final + presupuesto producción'
      }
    }
  },
  created () {
    this.$router.push({ name: 'orders_edit', params: { id: this.order.id } })
    this.current_order = JSON.parse(JSON.stringify(this.order))
  },
  computed: {
    locations () {
      return this.$store.getters['locations/getLocations']
    },

    types () {
      return this.$store.getters['files/getTypesCustomizable']
    },

    status_color () {
      return this.status[this.current_order.status].color
    }
  },
  methods: {
    back () {
      this.$store.commit('orders/setCurrentOrder', false)
      this.$router.push({ name: 'admin_orders' })
    },
    formatDate (date) {
      return moment(date).format('HH:mm DD/MM/YYYY')
    },
    save () {
      var self = this
      this.$store
        .dispatch('orders/uploadOrder', this.current_order)
        .then(function () {
          self.$store.commit('orders/setCurrentOrder', false)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .contact_info {
    width: 40%;
    float: left;
    padding: 0 40px;
    margin-top: 25px;

    .subtitle {
      text-transform: uppercase;
    }

    .param {
      width: 100%;
      overflow: hidden;
      text-align: left;
      // font-size: 13px;

      .label {
        color: #999;
        float: left;
        width: 125px;
        text-align: left;
      }

      b {
        // font-weight: lighter;
        text-align: left;
      }
    }

    select {
      width: fit-content;
      height: 40px;
      /* max-height: unset; */
      text-align: center;
      border: none;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius: 3px;
    }

    .buttons {
      margin: 20px 0;
    }
  }

  .content {
    width: 60%;
    float: left;
    text-align: left;
    padding: 0 0 0 0;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }
    .custom {
      padding-left: 20px;
      font-size: 12px;
    }

    .item {
      margin-top: 20px;
      width: 100%;
      display: block;
      padding: 10px 0;
      overflow: hidden;
      text-align: left;
      padding: 15px 25px;
      background-color: #eee;
      border-radius: 3px;

      .box-resume {
        width: 100%;
        display: block;
        float: left;

        .image {
          width: 100px;
          float: left;
          padding: 5px;
        }
        .container {
          width: calc(100% - 100px);
          float: left;
          padding: 5px 15px;

          .to,
          .from {
            margin-bottom: 15px;
            width: 50%;
            display: block;
            float: left;

            .label {
              text-transform: uppercase;
              margin-top: 10px;
              font-weight: bold;
            }

            .item {
              padding: 0;
              width: 100%;
              margin: 0;

              .value {
                padding-left: 10px;
                font-weight: bold;
              }
            }

            .name {
              font-family: Speedee-Bold;

              .print {
                background: var(--main_color);
                padding: 3px 10px;
                border-radius: 15px;
                font-size: 10px;
                margin-left: 10px;
              }
            }
            .size {
              font-size: 13px;
            }
          }
          .param {
            overflow: hidden;
            font-size: 12px;

            .label {
              color: #999;
              float: left;
              width: 100px;
            }

            b {
              font-weight: lighter;
            }
          }
        }
      }

      .box-info {
        width: 100%;
        border-top: 1px solid #fff;
        display: block;
        float: left;
        padding-top: 10px;

        .personalitzation,
        .questions {
          margin-bottom: 15px;
          width: 50%;
          display: block;
          float: left;

          .item {
            padding: 0;
            width: 100%;
            margin: 0;

            &.title {
              font-weight: bold;

              label {
                font-size: 14px;
              }
            }

            .value {
              padding-left: 10px;
              font-weight: bold;
              font-size: 14px;
            }
          }

          .name {
            font-family: Speedee-Bold;

            .print {
              background: var(--main_color);
              padding: 3px 10px;
              border-radius: 15px;
              font-size: 10px;
              margin-left: 10px;
            }
          }
          .size {
            font-size: 13px;
          }
        }
        .param {
          overflow: hidden;
          font-size: 12px;

          .label {
            color: #999;
            float: left;
            width: 100px;
          }

          b {
            font-weight: lighter;
          }
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}
</style>
